<div class="flight-shop">
  <ng-container [ngSwitch]="flightShopWidgetTemplates">
    <idp-home-book-widget
      *ngSwitchCase="FlightShopWidgetTemplates.HOME"
      [isDesktop]="isDesktop"
      [bookWidgetFields]="bookWidgetFields$ | ngrxPush"
      [guidedNavigationErrorMsg]="guidedNavigationErrorMsg$ | ngrxPush"
      [bookWidgetAem]="bookWidgetAem$ | ngrxPush"
      [searchModalTabs]="(searchModalTabs$ | ngrxPush) || []"
      [recentSearchList]="(searchModalRecentSearchList$ | ngrxPush) || []"
      [savedSearchList]="(searchModalSavedSearchList$ | ngrxPush) || []"
      [predictiveSearchList]="
        (searchModalPredictiveSearchList$ | ngrxPush) || []
      "
      [viewSearchOptionExpanded]="viewSearchOptionExpanded"
      [datepickerConfig]="datepickerConfig"
      (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
      (swapAirports)="swapAirportsHandler($event)"
      (findFlight)="findFlightClicked()"
      (addFlightsForMc)="addFlightsForMcHandler()"
      (removeFlightForMc)="removeFlightForMcHandler()"
      (searchModalEvent)="handleSearchModalEvent($event)"
      (viewSearchOptionEvent)="onViewSearchOptionsHandler()"
      (analyticsEvent)="handleAnalytics($event)"
    ></idp-home-book-widget>
    <idp-apps-book-widget
      *ngSwitchCase="FlightShopWidgetTemplates.APP"
      [isDesktop]="isDesktop"
      [isBookWidgetReady]="(isBookWidgetReady$ | ngrxPush) || false"
      [bookWidgetFields]="bookWidgetFields$ | ngrxPush"
      [guidedNavigationErrorMsg]="guidedNavigationErrorMsg$ | ngrxPush"
      [bookWidgetAem]="bookWidgetAem$ | ngrxPush"
      [searchModalTabs]="(searchModalTabs$ | ngrxPush) || []"
      [recentSearchList]="(searchModalRecentSearchList$ | ngrxPush) || []"
      [savedSearchList]="(searchModalSavedSearchList$ | ngrxPush) || []"
      [predictiveSearchList]="
        (searchModalPredictiveSearchList$ | ngrxPush) || []
      "
      [datepickerConfig]="datepickerConfig"
      (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
      (swapAirports)="swapAirportsHandler($event)"
      (findFlight)="findFlightClicked()"
      (addFlightsForMc)="addFlightsForMcHandler()"
      (removeFlightForMc)="removeFlightForMcHandler()"
      (searchModalEvent)="handleSearchModalEvent($event)"
    ></idp-apps-book-widget>
    <idp-modify-book-widget
      *ngSwitchCase="FlightShopWidgetTemplates.MODIFY"
      [isDesktop]="isDesktop"
      [isBookWidgetReady]="(isBookWidgetReady$ | ngrxPush) || false"
      [bookWidgetFields]="bookWidgetFields$ | ngrxPush"
      [guidedNavigationErrorMsg]="guidedNavigationErrorMsg$ | ngrxPush"
      [bookWidgetAem]="bookWidgetAem$ | ngrxPush"
      [searchModalTabs]="(searchModalTabs$ | ngrxPush) || []"
      [recentSearchList]="(searchModalRecentSearchList$ | ngrxPush) || []"
      [savedSearchList]="(searchModalSavedSearchList$ | ngrxPush) || []"
      [predictiveSearchList]="
        (searchModalPredictiveSearchList$ | ngrxPush) || []
      "
      [datepickerConfig]="datepickerConfig"
      (bookWidgetFieldChange)="bookWidgetFieldChangeHandler($event)"
      (swapAirports)="swapAirportsHandler($event)"
      (findFlight)="findFlightClicked()"
      (addFlightsForMc)="addFlightsForMcHandler()"
      (removeFlightForMc)="removeFlightForMcHandler()"
      (searchModalEvent)="handleSearchModalEvent($event)"
      (viewSearchOptionEvent)="onViewSearchOptionsHandler()"
    ></idp-modify-book-widget>
  </ng-container>
</div>
